export function AddOrRemove<T>(key: string, store: T | undefined, storageType: 'localStorage' | 'sessionStorage' = 'localStorage'): void {
  const canStore = store !== undefined ? JSON.stringify(store) : undefined;
  if (storageType === 'localStorage') {
    if (canStore) { localStorage.setItem(key, canStore); }
    else { localStorage.removeItem(key); }
  } else {
    if (canStore) { sessionStorage.setItem(key, canStore); }
    else { sessionStorage.removeItem(key); }
  }
}

export function FetchCache<T>(key: string, storageType: 'localStorage' | 'sessionStorage' = 'localStorage'): T | undefined {
  try {
    if (storageType === 'localStorage') {
      const str = localStorage.getItem(key);
      return str != null ? JSON.parse(str) : undefined;
    } else {
      const str = sessionStorage.getItem(key);
      return str != null ? JSON.parse(str) : undefined;
    }
  } catch (e) {
    return undefined;
  }
}


